import moment from 'moment'

export function formatDate(isoDate) {
  return moment.utc(Date.parse(isoDate)).format('MMMM D, YYYY')
}

export function shortDate(date) {
  return moment(date).format('MM/DD')
}
